<app-rive-loader *ngIf="isRiveClient"></app-rive-loader>

<tui-loader *ngIf="!isRiveClient" size="xl" [showLoader]="true"></tui-loader>
